import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { getThemeColor } from '@/utils/themes'
import { rem } from '@/utils/helpers'
import Typography from '@/components/common/Typography'
import Number from './Number'

const Template = props => {
  const { theme, number, content, ...others } = props
  return (
    <Root theme={theme} {...others}>
      <Number css={styles.Number} color="primary">{number}</Number>
      <Content theme={theme} variant="h4" component="div">{content}</Content>
    </Root>
  )
}

export default ThemeConsumer(Template)

const Root = styled.div`
  padding: ${rem(24)} ${rem(12)};
  border-radius: ${rem(10)};
  border: 1px solid ${props => getThemeColor('primary', props.theme)};
  text-align: center;
`

const Content = styled(Typography)`
  margin-top: ${rem(16)};
  strong {
    font-size: 1.4285714286em;
    color: ${props => getThemeColor('primary', props.theme)};
  }
`

const styles = {
  Number: css`
    margin: 0 auto;
  `
}
